import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  LogoFacebook32,
  LogoYoutube32,
  LogoInstagram32,
  LogoTwitter32,
} from '@carbon/icons-react';
import { withTranslation } from 'react-i18next';
import { animateScroll as scroll } from 'react-scroll';
import LoadingIndicator from './loading-indicator';
import OpeningHours from './opening-hours';

class PageFooter extends Component {
  render() {
    if (this.props.footerConfig && this.props.footerMenu) {
      return (
        <>
          <div className="upper">
            <div className="up-to-top d-none d-md-block" onClick={() => scroll.scrollToTop()}>
              <img src="/themes/custom/module_box/src/images/Bildlauf-hoch.svg" alt=""/>
            </div>
            <div className="container">
              {this.props.footerConfig && this.props.footerMenu &&
              <>
                <div className="row">
                  <div className="col-lg-4 order-lg-1 col-wrapper">
                    <div className="social-media d-sm-flex d-lg-none">
                      {this.props.footerConfig.fieldInstagram &&
                        <a target="_blank"
                           rel="noopener noreferrer"
                           href={this.props.footerConfig.fieldInstagram.url.path}>
                          <LogoInstagram32/>
                        </a>
                      }
                      {this.props.footerConfig.fieldFacebook &&
                        <a target="_blank"
                           rel="noopener noreferrer"
                           href={this.props.footerConfig.fieldFacebook.url.path}>
                          <LogoFacebook32/>
                        </a>
                      }
                      {this.props.footerConfig.fieldYoutube &&
                        <a target="_blank"
                           rel="noopener noreferrer"
                           href={this.props.footerConfig.fieldYoutube.url.path}>
                          <LogoYoutube32/>
                        </a>
                      }
                      {this.props.footerConfig.fieldTwitter &&
                        <a target="_blank"
                           rel="noopener noreferrer"
                           href={this.props.footerConfig.fieldTwitter.url.path}>
                          <LogoTwitter32/>
                        </a>
                      }
                    </div>
                    {!!this.props.footerConfig.fieldAdresseFooter &&
                    <div className="address" dangerouslySetInnerHTML={{ __html: this.props.footerConfig.fieldAdresseFooter.value }} />
                    }
                  </div>
                  <div className="col-lg-4 order-lg-3 col-wrapper d-none d-lg-flex">
                    <div className="opening-times">
                      <img src="/themes/custom/module_box/src/images/Oeffnungszeit-Uhr.svg" alt=""/>
                      <div className="text">
                        <div className="header">
                          <a href={"/" + this.props.i18n.language + "/node/36"}>{this.props.t('Heute geöffnet')}</a>
                        </div>
                        <div className="time">
                          <OpeningHours />
                        </div>
                      </div>
                    </div>
                    {this.props.footerConfig.fieldFaqSeite &&
                    <div className="faq">
                      <img
                        src="/themes/custom/module_box/src/images/FAQ-haeufige_Fragen-svg.svg"
                        alt=""/>
                      <a className="text" href={this.props.footerConfig.fieldFaqSeite.url.path}>
                        {this.props.footerConfig.fieldFaqSeite.title}
                      </a>
                    </div>
                    }
                  </div>
                  <div className="col-lg-4 order-lg-2 col-wrapper">
                    <div className="social-media d-none d-lg-flex">
                      {this.props.footerConfig.fieldInstagram &&
                        <a target="_blank"
                           rel="noopener noreferrer"
                           href={this.props.footerConfig.fieldInstagram.url.path}>
                          <LogoInstagram32/>
                        </a>
                      }
                      {this.props.footerConfig.fieldFacebook &&
                        <a target="_blank"
                           rel="noopener noreferrer"
                           href={this.props.footerConfig.fieldFacebook.url.path}>
                          <LogoFacebook32/>
                        </a>
                      }
                      {this.props.footerConfig.fieldYoutube &&
                        <a target="_blank"
                           rel="noopener noreferrer"
                           href={this.props.footerConfig.fieldYoutube.url.path}>
                          <LogoYoutube32/>
                        </a>
                      }
                      {this.props.footerConfig.fieldTwitter &&
                        <a target="_blank"
                           rel="noopener noreferrer"
                           href={this.props.footerConfig.fieldTwitter.url.path}>
                          <LogoTwitter32/>
                        </a>
                      }
                    </div>
                    <div className="footer">
                      <nav className="footer-menu">
                        <ul>
                          {this.props.footerMenu.links.map((item, index) =>
                            <li key={index}>
                              <a href={item.url.path}>
                                {item.label}
                              </a>
                            </li>
                          )}
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </>
              }
            </div>
          </div>
          {this.props.footerLogoRow && this.props.footerLogoRow.fieldLogo.length > 0 &&
            <div className="downer">
              <div className="container">
                <div className="row">
                  {this.props.footerLogoRow.fieldLogo.map((logoEntry, i) => {
                    return (
                      <div className="col-sm-12 col-md-6 col-lg-4 col-wrapper">
                        <h3>{logoEntry.customCaption}</h3>
                        <img src={logoEntry.entity.fieldMediaImage.url}/>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          }
        </>
      );
    }

    return <LoadingIndicator />;
  }
}

PageFooter.propTypes = {
  footerConfig: PropTypes.object,
  footerMenu: PropTypes.object
};

export default withTranslation()(PageFooter);
